export default __webpack_public_path__ + "static/media/oxoxo.6d63c757.svg";